export class UserFriendlyError implements Error {
  public static readonly identifier = 'UserFriendlyError';
  constructor(public readonly message: string, public readonly error?: any | null) {}
  public readonly name = UserFriendlyError.identifier;
}

export class Warning implements Error {
  public static readonly identifier = 'Warning';
  constructor(public readonly message: string, public readonly error?: any | null) {}
  public readonly name = Warning.identifier;
}
export class FatalError implements Error {
  public static readonly identifier = 'FatalError';
  constructor(public readonly message: string, public readonly error?: any | null) {}
  public readonly name = FatalError.identifier;
}
